import { getIsVinculacaoCuidadoAtiva } from '@atendimento/detail/soap/plano/cuidado-compartilhado/cuidado-compartilhado-form/utils-cuidadoCompartilhado'
import { CustomSelectFieldProps, SelectField } from 'components/form/final-form'
import { useFlags } from 'config/useFlagsContext'
import { EspecialidadesEsusRegSelectFieldDocument } from 'graphql/hooks.generated'
import {
  EspecialidadesEsusRegSelectFieldQuery,
  EspecialidadesEsusRegSelectFieldQueryVariables,
} from 'graphql/types.generated'

import { DEFAULT_SELECT_PAGE_PARAM, useAsyncQuerySelect } from '../useAsyncQuerySelect'

export type EspecialidadesEsusRegSelectFieldModel = {
  readonly id: string
  readonly nome: string
}

type EspecialidadesEsusRegSelectFieldProps = CustomSelectFieldProps<EspecialidadesEsusRegSelectFieldModel> & {
  isAtendimentoOdonto?: boolean
}

export default function EspecialidadesEsusRegSelectField(props: Readonly<EspecialidadesEsusRegSelectFieldProps>) {
  const { isAtendimentoOdonto = false, ...rest } = props

  const flags = useFlags()
  const isVinculacaoAtiva = getIsVinculacaoCuidadoAtiva(flags, isAtendimentoOdonto)

  const { selectProps } = useAsyncQuerySelect<
    EspecialidadesEsusRegSelectFieldModel,
    EspecialidadesEsusRegSelectFieldQuery,
    EspecialidadesEsusRegSelectFieldQueryVariables
  >({
    query: EspecialidadesEsusRegSelectFieldDocument,
    extractItems: (data) => data?.especialidadesEsusReg.content,
    variables: (inputQuery: string): EspecialidadesEsusRegSelectFieldQueryVariables => ({
      input: {
        query: inputQuery,
        filtroPadrao: true,
        onlyOdontologico: isAtendimentoOdonto && isVinculacaoAtiva,
        pageParams: DEFAULT_SELECT_PAGE_PARAM,
      },
    }),
  })

  return <SelectField<EspecialidadesEsusRegSelectFieldModel> itemToString={itemToString} {...selectProps} {...rest} />
}

const itemToString = (item: EspecialidadesEsusRegSelectFieldModel) => item?.nome
